<template>
  <ion-page>
    <topbar>
      <menubar />
      <ion-toolbar>
        <ion-searchbar
          :placeholder="$t('general.search')"
          :search-icon="loading ? ellipsisHorizontalOutline : searchOutline"
          :debounce="500"
          @update:modelValue="handleSearch"
          @ionClear="handleSearch('')"
        />
      </ion-toolbar>
    </topbar>
    <ion-content
      fullscreen
    >
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="ion-no-margin ion-text-center"
              @click="$router.push({ name: 'collection', params: { collection: collection_slug } })"
            >
              <ion-img src="/img/brigant.webp" :alt="collection_name" />
              <ion-card-header>
                <ion-card-title>{{ collection_name }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="ion-no-margin ion-text-center"
              @click="checkLogin(() => $router.push({ name: 'lasts-supplements-foils' }))"
            >
              <ion-img src="/img/lasts-supplements-foils.webp" :alt="$t('order.lasts_supplements_foils')" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.lasts_supplements_foils') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="ion-no-margin ion-text-center"
              @click="checkLogin(() => $router.push({ name: 'custom-order' }))"
            >
              <ion-img src="/img/custom.webp" :alt="$t('orders.custom')" />
              <ion-card-header>
                <ion-card-title>{{ $t('orders.custom') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="ion-no-margin ion-text-center"
              @click="$router.push({ name: 'collection', params: { collection: 'classics' } })"
            >
              <ion-img src="/img/classic.webp" :alt="$t('order.classics')" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.classics') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="ion-no-margin ion-text-center"
              :class="{ 'coming-soon': !finishing_enabled }"
              @click="checkLogin(() => $router.push({ name: 'finishing' }))"
            >
              <ion-img v-if="finishing_enabled" src="img/finishing.webp" :alt="$t('order.finishing')" />
              <div v-else class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.finishing') }}</ion-card-title>
              </ion-card-header>
              <div v-if="!finishing_enabled" class="soon-text">
                {{ $t('general.coming_soon') }}
              </div>
              <div v-if="!finishing_enabled" class="overlay" />
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3" class="ion-hide">
            <ion-card
              class="ion-no-margin ion-text-center"
              @click="$router.push({ name: 'collection', params: { collection: 'basics' } })"
            >
              <!-- <ion-img src="/img/basics.webp" :alt="$t('order.basics')" /> -->
              <div class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.basics') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="ion-no-margin ion-text-center"
              :class="{ 'coming-soon': !flea_enabled }"
              @click="checkLogin(() => $router.push({ name: 'flea-shoes' }))"
            >
              <ion-img v-if="flea_enabled" src="img/flea.webp" :alt="$t('order.flea')" />
              <div v-else class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.flea') }}</ion-card-title>
              </ion-card-header>
              <div v-if="!flea_enabled" class="soon-text">
                {{ $t('general.coming_soon') }}
              </div>
              <div v-if="!flea_enabled" class="overlay" />
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="ion-no-margin ion-text-center"
              @click="checkLogin(() => $router.push({ name: 'bath-shoes' }))"
            >
              <ion-img src="/img/bath-shoe.webp" :alt="$t('order.bath_shoe')" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.bath_shoe') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col size="12" size-sm="3">
            <ion-card
              class="coming-soon ion-no-margin ion-text-center"
            >
              <!-- <ion-img src="/img/basics.webp" :alt="$t('order.basics')" /> -->
              <div class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.basics') }}</ion-card-title>
              </ion-card-header>
              <div class="soon-text">
                {{ $t('general.coming_soon') }}
              </div>
              <div class="overlay" />
            </ion-card>
          </ion-col>
          <ion-col class="ion-hide" size="12" size-sm="3">
            <ion-card class="coming-soon ion-no-margin ion-text-center">
              <!-- <ion-img src="/img/casing.webp" :alt="$t('order.leg_cover')" /> -->
              <div class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.leg_cover') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col class="ion-hide" size="12" size-sm="3">
            <ion-card class="coming-soon ion-no-margin ion-text-center">
              <!-- <ion-img src="/img/liner-shoe.webp" :alt="$t('order.liner_shoe')" /> -->
              <div class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.liner_shoe') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col class="ion-hide" size="12" size-sm="3">
            <ion-card class="coming-soon ion-no-margin ion-text-center">
              <!-- <ion-img src="/img/trial-shoe.webp" :alt="$t('order.trial_shoe')" /> -->
              <div class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.trial_shoe') }}</ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
          <ion-col class="ion-hide" size="12" size-sm="3">
            <ion-card class="coming-soon ion-no-margin ion-text-center">
              <!-- <ion-img src="/img/slipper.webp" :alt="$t('order.slipper')" /> -->
              <div class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.slipper') }}</ion-card-title>
              </ion-card-header>
              <div class="soon-text">
                {{ $t('general.coming_soon') }}
              </div>
              <div class="overlay" />
            </ion-card>
          </ion-col>
          <ion-col class="ion-hide" size="12" size-sm="3">
            <ion-card class="coming-soon ion-no-margin ion-text-center">
              <!-- <ion-img src="/img/sock-shoe.webp" :alt="$t('order.sock_shoe')" /> -->
              <div class="h-100" />
              <ion-card-header>
                <ion-card-title>{{ $t('order.sock_shoe') }}</ion-card-title>
              </ion-card-header>
              <div class="soon-text">
                {{ $t('general.coming_soon') }}
              </div>
              <div class="overlay" />
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>
<script>
import { defineComponent } from 'vue';
import {
  IonSearchbar, IonImg,
} from '@ionic/vue';
import {
  ellipsisHorizontalOutline,
  menuOutline,
  cart,
  person,
  arrowForwardCircleOutline,
  searchOutline,
} from 'ionicons/icons';
import ImageMixin from '@/mixins/ImageMixin';
import LoaderMixin from '@/mixins/LoaderMixin';
import UserMixin from '@/mixins/UserMixin';
import Menubar from '@/components/Menubar.vue';
import Topbar from '@/components/Topbar.vue';

export default defineComponent({
  components: {
    IonSearchbar,
    IonImg,
    Menubar,
    Topbar,
  },
  mixins: [ImageMixin, LoaderMixin, UserMixin],
  setup() {
    return {
      ellipsisHorizontalOutline,
      menuOutline,
      cart,
      person,
      arrowForwardCircleOutline,
      searchOutline,
    };
  },
  data() {
    return {
      loading: false,
      search: '',
    };
  },
  methods: {
    /**
     * Handle search input
     *
     * @param {String} search
     */
    handleSearch(search) {
      if (search.length > 1) {
        this.$router.push({ name: 'search', params: { search } });
      }
    },
  },
});
</script>

<style scoped>
ion-card {
  height: 100%;

  ion-img {
    height: 100px;
  }

  ion-card-title {
    font-size: 14px;

    --color: var(--ion-color-primary);
  }
}

.coming-soon {
  position: relative;
  box-shadow: none;
  user-select: none;

  .img {
    opacity: 0.05;
  }

  ion-card-title {
    opacity: 0.2;
  }
}

.soon-text {
  position: absolute;
  z-index: 10;
  top: 50%;
  right: 0;
  left: 0;
  color: white;
  font-size: 16px;
  font-weight: bold;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background-color: var(--ion-color-primary);
}
</style>
